<template>
  <v-container fluid>
    <v-card class="justify-center align-center" style="padding: 0;">
      <v-card-text>
      <v-row class="justify-center align-center">

        <div class="leftItem">
          <v-card flat class="rounded vue-logo"/>
        </div>
        <div class="centerItem">
          <v-card flat>
            <strong class="d-block">{{ item.title }}</strong>
            <span>Quantity: {{ item.quantity }} - {{ item.price | formatMoney }}</span>
          </v-card >

        </div>
        <div class="rightItem">
          <v-card flat>
            <RemoveFromCart :product="item"/>
          </v-card >
        </div>

      </v-row>
        </v-card-text>

    </v-card>
  </v-container>
</template>


<script>
import RemoveFromCart from './../products/RemoveFromCart'

export default {
  name: 'ShoppingCartItem',
  props: {
    item: Object
  },
  components: {RemoveFromCart}
}
</script>

<style scoped>
.vue-logo {
  height: 50px;
  width: 50px;
  background: url('./../../../assets/logo.png') no-repeat center center #ddd;
  background-size: 45%;
}

.leftItem {
  grid-column: 1;
  grid-row: 1;
  padding-right: 0.2rem;
  justify-content: left;
}

.centerItem {
  grid-column: 2;
  grid-row: 1;
  padding-right: 1rem;
  justify-content: left;
}

.rightItem {
  grid-column: 3;
  grid-row: 1;
  justify-content: right;
}
</style>
